var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-popup',{ref:"popup",staticClass:"popup",attrs:{"visible":_vm.show,"close-on-outside-click":true,"show-title":true,"title":_vm.title,"onHidden":_vm.hide,"maxHeight":_vm.height,"maxWidth":_vm.width,"full-screen":_vm.fullscreen,"drag-enabled":true,"resize-enabled":true}},[(_vm.allowFullscreen)?_c('dx-toolbar-item',{attrs:{"widget":"dxButton","location":"before","options":{
      disabled: false,
      onClick: function () {
        _vm.fullscreen = !_vm.fullscreen;
      },
      type: 'success',
      icon: _vm.fullscreen
        ? 'fas fa-compress-arrows-alt'
        : 'fas fa-expand-arrows-alt',
    }}}):_vm._e(),(_vm.showSave)?_c('dx-toolbar-item',{attrs:{"widget":"dxButton","location":"after","options":{
      disabled: _vm.saving,
      text: _vm.isEditing ? _vm.$t('buttons.Edit') : _vm.$t('buttons.Save'),
      onClick: _vm.save,
      stylingMode: 'outlined',
      type: 'default',
      icon: _vm.saving ? 'fas fa-spin fa-spinner' : 'fas fa-save',
    }}}):_vm._e(),(_vm.showDelete)?_c('dx-toolbar-item',{attrs:{"widget":"dxButton","location":"after","options":{
      disabled: _vm.saving,
      text: _vm.$t('buttons.Remove'),
      onClick: _vm.remove,
      stylingMode: 'outlined',
      type: 'error',
      icon: _vm.saving ? 'fas fa-spin fa-spinner' : 'fas fa-trash',
    }}}):_vm._e(),_c('dx-scroll-view',[_vm._t("body")],2),_vm._t("bottom-toolbar")],2)}
var staticRenderFns = []

export { render, staticRenderFns }